export default {
  teamMembers: {
    items: [],
    loading: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: ['email'],
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
      search: '',
    },
  },
};
